import { useState, useEffect } from 'react';
import { db } from "./firebase"
import { collection, getDocs, onSnapshot } from "firebase/firestore"
import GamingComponent from './components/Gaming';
import NotGamingComponent from './components/NotGaming'

function App() {

  const [gameData, setGameData] = useState([]);
  const [isGaming, setGaming] = useState(false);

  useEffect(() => {
    const datas = collection(db, "nowGame");
    getDocs(datas).then((snapShot) => {
      const gameData = snapShot.docs.map((data) => ({ ...data.data() }));
      setGameData(gameData);
      const gaming = gameData.some((data) => data.isGaming);
      setGaming(gaming);

      onSnapshot(datas, (data) => {
        const gameData = data.docs.map((data) => ({ ...data.data() }));
        setGameData(gameData);
        const gaming = gameData.some((data) => data.isGaming);
        setGaming(gaming);
      })
    })
  }, [])

  return (
    <div className="container">
      {gameData.length === 0 ? (
        <p>Loading...</p>
      ) : (
        <div className='container'>
          {isGaming ? <GamingComponent /> : <NotGamingComponent />}
        </div>
      )
      }
    </div>
  );
}

export default App;